module.exports = __webpack_public_path__ + "static/GrayPruszczGdanski-6c83056b76315deb3c4511aad4944e80.svg";